export default __webpack_public_path__ + "static/media/logo-footer-img-1-300x78.74ab5511.png";